import { render, staticRenderFns } from "./mySupplierPay.vue?vue&type=template&id=42b584e0&scoped=true"
import script from "./mySupplierPay.vue?vue&type=script&lang=js"
export * from "./mySupplierPay.vue?vue&type=script&lang=js"
import style0 from "./mySupplierPay.vue?vue&type=style&index=0&id=42b584e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b584e0",
  null
  
)

export default component.exports